import {Inject, PLATFORM_ID} from '@angular/core';

export class AnimateArrow {
    currentInterval: NodeJS.Timer;
    currentTimeout: NodeJS.Timer;
    stopTimeout: NodeJS.Timer;
    intervalTime: number = 1400;

    animate(element) {
        clearInterval(this.currentInterval);
        clearTimeout(this.stopTimeout);

        const i = element.getElementsByTagName('i')[0];
        let firstContainer = i ? i.parentElement : element;

        firstContainer.classList.add("arrow-anim-reverse");
        setTimeout(() => {
            firstContainer.classList.remove("arrow-anim-reverse");
            firstContainer.classList.add("arrow-anim");

            this.doAnimation(firstContainer);
            this.currentInterval = setInterval(() => {
                this.doAnimation(firstContainer);
            }, this.intervalTime);
        }, 1);
    }

    stopAnimation(firstContainer) {
        clearInterval(this.currentInterval);
        firstContainer.classList.remove("arrow-anim");
        firstContainer.classList.add("arrow-anim-reverse");
    }

    private doAnimation(firstContainer) {
        firstContainer.classList.remove("arrow-anim-reverse");
        firstContainer.classList.add("arrow-anim");

        clearTimeout(this.currentTimeout);

        this.currentTimeout = setTimeout(() => {
            firstContainer.classList.remove("arrow-anim");
            firstContainer.classList.add("arrow-anim-reverse");
        }, this.intervalTime / 2);
    }
}
